var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { attrs: { "label-width": "120px" } },
    [
      _c(
        "el-form-item",
        {
          attrs: { label: "" + _vm.$t("GlobalSetObj.downloadImportTemplate") },
        },
        [
          _c("el-button", { attrs: { type: "text", icon: "el-icon-edit" } }, [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.importTmpUrl,
                  download: _vm.$t("uploadFile.template") + ".xlsx",
                },
              },
              [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          attrs: { label: " " },
        },
        [
          _c("input", {
            ref: "uploadInputRef",
            staticClass: "excel-upload-input",
            attrs: { type: "file", accept: ".xlsx, .xls" },
            on: { change: _vm.handleClick },
          }),
        ]
      ),
      _c(
        "el-form-item",
        { attrs: { label: "" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                icon: "el-icon-upload2",
                loading: _vm.loading,
                size: "small",
                type: "primary",
              },
              on: { click: _vm.handleUpload },
            },
            [_vm._v(" " + _vm._s(_vm.$t("uploadFile.uploadFiles")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }